var map = {
	"./home": [
		"FP3a",
		0
	],
	"./home/": [
		"FP3a",
		0
	],
	"./home/components/banner-section": [
		"CJE4",
		2
	],
	"./home/components/banner-section.vue": [
		"CJE4",
		2
	],
	"./home/components/content-section": [
		"R7p8",
		1
	],
	"./home/components/content-section.vue": [
		"R7p8",
		1
	],
	"./home/index": [
		"FP3a",
		0
	],
	"./home/index.vue": [
		"FP3a",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5BXs";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages lazy ^\.\/.*$
// module id = 5BXs
// module chunks = 4